import { PRE_RELEASE_CODES, SOLD_OUT_CODES, } from "@cappelendamm/e-commerce-services";
import Logger from "@cappelendamm/logger";
export function getImmediacyScore({ publicationTimestamp, statusCode, objectID, canBeSold, isDefaultVariant, }) {
    if (!publicationTimestamp) {
        Logger.warn(`Item without publicationTimestamp. ObjectID: ${objectID}`);
        return 0;
    }
    const initialScore = publicationTimestamp * (canBeSold ? 1 : 0);
    // Apply isDefaultVariant factor: multiply by 1 if default, 7/10 if not default
    const variantFactor = isDefaultVariant ? 1 : 7 / 10;
    const scoreWithVariantFactor = initialScore * variantFactor;
    if (statusCode && PRE_RELEASE_CODES.has(statusCode))
        return scoreWithVariantFactor * (2 / 3);
    if (statusCode && SOLD_OUT_CODES.has(statusCode))
        return scoreWithVariantFactor * (1 / 3);
    return scoreWithVariantFactor;
}
